// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Select_wrapper__2oMPP","root":"Select_root__2iZKT","icon":"Select_icon__84AcZ","select-css":"Select_select-css__2rEhZ"};